import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import ActionPointDisplay from "@/modules/team/components/ActionPointDisplay.vue";
import { GateTypeEnum } from "@/modules/action-points/enums";
export default /*#__PURE__*/_defineComponent({
  __name: 'GatePointDisplay',
  props: {
    gateType: null,
    value: null,
    rounded: {
      type: Boolean
    },
    horizontal: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const isMoney = computed(() => props.gateType === GateTypeEnum.BALANCE);
    const colorMap = ref({
      [GateTypeEnum.COINS]: ColorEnum.Gold,
      [GateTypeEnum.BALANCE]: ColorEnum.Green,
      [GateTypeEnum.TRAINING_GK]: ColorEnum.Red,
      [GateTypeEnum.TRAINING_DF]: ColorEnum.Red,
      [GateTypeEnum.TRAINING_MF]: ColorEnum.Red,
      [GateTypeEnum.TRAINING_AT]: ColorEnum.Red,
      [GateTypeEnum.NEGOTIATION]: ColorEnum.Fuchsia,
      [GateTypeEnum.SCOUTING]: ColorEnum.Sky
    });
    const iconMap = ref({
      [GateTypeEnum.COINS]: IconEnum.Coins,
      [GateTypeEnum.BALANCE]: IconEnum.EuroFilled,
      [GateTypeEnum.TRAINING_GK]: IconEnum.Dumbbell,
      [GateTypeEnum.TRAINING_DF]: IconEnum.Dumbbell,
      [GateTypeEnum.TRAINING_MF]: IconEnum.Dumbbell,
      [GateTypeEnum.TRAINING_AT]: IconEnum.Dumbbell,
      [GateTypeEnum.NEGOTIATION]: IconEnum.Handshake20Regular,
      [GateTypeEnum.SCOUTING]: IconEnum.Binoculars
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(ActionPointDisplay, _mergeProps(Object.assign({
        rounded: __props.rounded,
        horizontal: __props.horizontal,
        value: __props.value
      }, _ctx.$attrs), {
        color: colorMap.value[__props.gateType],
        icon: iconMap.value[__props.gateType]
      }), _createSlots({
        _: 2
      }, [_unref(isMoney) ? {
        name: "value",
        fn: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$money(__props.value)), 1)])
      } : undefined]), 1040, ["color", "icon"])]);
    };
  }
});